import { Link } from "react-router-dom";
import { birdTypes, exoticTypes } from "../../mocks/home-data";
import FadeIn from "../../components/base/FadeIn";
import PageHero from "../../components/feature/PageHero";

const birdServices = [
  {
    title: "Egzotik Hayvan Muayenesi",
    description: "Kuşlar ve egzotik türlere özel hassas muayene ve değerlendirme. Her türün anatomik ve fizyolojik özelliklerine uygun özel muayene teknikleri uyguluyoruz.",
    icon: "ri-stethoscope-line",
  },
  {
    title: "Beslenme ve Bakım Danışmanlığı",
    description: "Türüne uygun beslenme programları ve yaşam alanı düzenleme önerileri. Doğal habitatlarına en yakın ortamı oluşturmak için özel rehberlik.",
    icon: "ri-restaurant-line",
  },
  {
    title: "Teşhis ve Tedavi",
    description: "Solunum yolu hastalıkları, sindirim problemleri, tüy ve deri hastalıklarına yönelik özel teşhis ve tedavi yaklaşımları.",
    icon: "ri-microscope-line",
  },
  {
    title: "Cerrahi ve Müdahale",
    description: "Kuş ve küçük egzotik hayvanlara uygun cerrahi işlemler ve hassas müdahaleler. Mini boyutlu cerrahi ekipmanlarla güvenli operasyonlar.",
    icon: "ri-knife-line",
  },
  {
    title: "Laboratuvar ve Mikrobiyoloji",
    description: "Dışkı analizi, mikroskobik inceleme ve enfeksiyon tespiti. Hızlı ve doğru laboratuvar sonuçları ile etkili tedavi planları.",
    icon: "ri-flask-line",
  },
  {
    title: "Röntgen ve Ultrason",
    description: "Kuş ve egzotik hayvanlar için özel dijital röntgen ve ultrasonografi hizmetleri. Hassas teşhis için modern görüntüleme teknolojisi.",
    icon: "ri-scan-line",
  },
];

const birdTypeList = [
  { name: "Kanarya", desc: "Renkli tüyleri ve melodik ötüşleriyle popüler süs kuşları", care: "Güneş ışığı, taze gıda, düzenli kafes temizliği" },
  { name: "Muhabbet Kuşu", desc: "Sevimli kişilikleri ve konuşma yetenekleriyle sevilen dostlar", care: "Sosyal etkileşim, çeşitli tohumlar, oyuncaklar" },
  { name: "Jako Papağanı", desc: "Yüksek zekaları ve konuşma yetenekleriyle öne çıkan papağan türü", care: "Zihinsel uyarım, kaliteli mama, düzenli muayene" },
  { name: "Sultan Papağanı", desc: "Sarı başlı, gri tüylü ve nazik kişilikleriyle sevilen papağan türü", care: "Tohum ve sebze ağırlıklı beslenme, geniş kafes, sosyal etkileşim" },
  { name: "Cennet Papağanı", desc: "Canlı renkleri ve oyuncu davranışlarıyla sevilen tür", care: "Çeşitli beslenme, sosyal ortam, tırnak bakımı" },
  { name: "Amazon Papağanı", desc: "Uzun ömürlü ve zeki papağan türleri arasında popüler", care: "Uzun vadeli bakım planı, düzenli kan tahlili" },
  { name: "Ara Papağanı", desc: "Büyük boyutları ve muhteşem renkleriyle kraliyet papağanı", care: "Geniş yaşam alanı, özel mama, düzenli kanat tırnak bakımı" },
  { name: "Hint Bülbülü", desc: "Ötüşleri ve zarif görünümleriyle Asya kökenli kuş türü", care: "Meyve ağırlıklı beslenme, banyo imkanı" },
  { name: "Zebra İspinozu", desc: "Küçük boyutları ve sosyal yapılarıyla popüler tür", care: "Sürü halinde bakım, tohum çeşitliliği" },
  { name: "Bıldırcın", desc: "Küçük süs kanatlıları ve yumurta üretimi için bakılan türler", care: "Yer seviyesi kafes, kum banyosu, protein ağırlıklı beslenme" },
];

const exoticTypeList = [
  { name: "Su Kaplumbağası", desc: "Yarı sucul yaşam süren popüler evcil sürüngen", care: "UVB ışık, su filtresi, kalsiyum takviyesi" },
  { name: "Leopar Gecko", desc: "Bakımı kolay ve renkli desenleriyle sevilen kertenkele", care: "Sıcak bölge, nem kontrolü, canlı yem" },
  { name: "İguana", desc: "Büyük boyutlu ve otçul beslenen tropikal sürüngen", care: "Geniz teraryum, UVB ışık, otçul beslenme" },
  { name: "Yılan Türleri", desc: "Çeşitli boyut ve türlerde bakımı yapılan sürüngenler", care: "Sıcaklık kontrolü, uygun yem, teraryum düzeni" },
  { name: "Hamster", desc: "Küçük boyutlu ve sevimli popüler kemirgen", care: "Koşu çarkı, tünel sistemi, çeşitli tohumlar" },
  { name: "Gine Domuzu", desc: "Sosyal yapıları ve sevimli kişilikleriyle sevilen kemirgen", care: "C vitamini takviyesi, geniz kafes, saman" },
  { name: "Tavşan", desc: "Uzun kulakları ve yumuşak tüyleriyle popüler evcil hayvan", care: "Saman ağırlıklı beslenme, geniz alan, tırnak bakımı" },
  { name: "Kirpi", desc: "Özel bakım gerektiren dikenli ve sevimli memeli", care: "Yüksek proteinli mama, ısı kontrolü, banyo" },
  { name: "Şeker Planörü", desc: "Uçabilen ve özel bakım gerektiren marsupial türü", care: "Özel mama, uçuş alanı, sosyal etkileşim" },
];

export default function ExoticBirds() {
  return (
    <main>
      <PageHero
        badge="Hizmet Alanımız"
        title={
          <>
            Kuş &{" "}
            <span className="font-serif italic text-primary-300">Egzotik</span>
            <br />
            Hayvan Hizmetleri
          </>
        }
        description="Ankara'da kuş ve egzotik hayvanlar konusunda en kapsamlı hizmeti sunuyoruz. Papağanlardan sürüngenlere, kemirgenlerden egzotik türlere kadar tüm dostlarınız için özel bakım ve tedavi programları hazırlıyoruz."
        backgroundImage="/assets/images/exotic-hero-bg.jpg"
      >
        <div className="flex flex-col sm:flex-row gap-4 mt-8">
          <a
            href="tel:05396960677"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-bold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          >
            <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
            0539 696 06 77
          </a>
          <Link
            to="/iletisim"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl border border-white/20 transition-all duration-300 whitespace-nowrap"
          >
            Randevu Al
          </Link>
        </div>
      </PageHero>

      {/* Services */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <FadeIn>
              <div className="text-center mb-16">
                <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-4">
                  Sunduğumuz Hizmetler
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Kuş & Egzotik Hayvanlar İçin{" "}
                  <span className="font-serif italic text-primary-700">Özel Hizmetler</span>
                </h2>
                <p className="text-gray-600 max-w-3xl mx-auto text-lg">
                  Her türün kendine özgü ihtiyaçlarına uygun, özel olarak tasarlanmış veteriner hizmetleri
                </p>
              </div>
            </FadeIn>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {birdServices.map((service, index) => (
                <FadeIn key={service.title} delay={index * 0.1}>
                  <div className="bg-cream-50 rounded-2xl p-7 md:p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 group h-full">
                    <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                      <i className={`${service.icon} text-2xl text-primary-700 w-6 h-6 flex items-center justify-center`} />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-primary-800 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Bird Types with Images */}
      <section className="py-16 md:py-24 bg-cream-50">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <FadeIn>
              <div className="text-center mb-16">
                <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-twitter-line text-2xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Bakılan{" "}
                  <span className="font-serif italic text-primary-700">Kuş Türleri</span>
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                  Tüm papağan türleri, kanarya, muhabbet kuşu ve daha fazlası için özel bakım
                </p>
              </div>
            </FadeIn>

            {/* Image Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
              {birdTypes.map((bird, index) => (
                <FadeIn key={bird.name} delay={index * 0.08}>
                  <div className="group relative rounded-2xl overflow-hidden aspect-square shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <img
                      src={bird.image}
                      alt={bird.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <p className="text-white font-bold text-sm">{bird.name}</p>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>

            {/* Detailed List */}
            <div className="grid sm:grid-cols-2 gap-4">
              {birdTypeList.map((bird, index) => (
                <FadeIn key={bird.name} delay={index * 0.05}>
                  <div className="bg-white rounded-xl p-5 transition-all duration-300 hover:shadow-md">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                        <i className="ri-twitter-line w-5 h-5 flex items-center justify-center text-primary-600" />
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900 mb-1">{bird.name}</h3>
                        <p className="text-sm text-gray-600 mb-2">{bird.desc}</p>
                        <p className="text-xs text-primary-600 font-medium">
                          <i className="ri-heart-line w-3 h-3 inline mr-1" />
                          {bird.care}
                        </p>
                      </div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Exotic Types */}
      <section className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            <FadeIn>
              <div className="text-center mb-16">
                <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-bug-line text-2xl text-primary-700 w-6 h-6 flex items-center justify-center" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                  Bakılan{" "}
                  <span className="font-serif italic text-primary-700">Egzotik Hayvanlar</span>
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-lg">
                  Sürüngenler, kemirgenler ve diğer egzotik türler için özel veteriner hizmetleri
                </p>
              </div>
            </FadeIn>

            {/* Image Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-12">
              {exoticTypes.map((exotic, index) => (
                <FadeIn key={exotic.name} delay={index * 0.1}>
                  <div className="group relative rounded-2xl overflow-hidden aspect-square shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <img
                      src={exotic.image}
                      alt={exotic.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <p className="text-white font-bold text-sm">{exotic.name}</p>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>

            {/* Detailed List */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {exoticTypeList.map((exotic, index) => (
                <FadeIn key={exotic.name} delay={index * 0.05}>
                  <div className="bg-cream-50 rounded-xl p-5 transition-all duration-300 hover:shadow-md">
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                        <i className="ri-bug-line w-5 h-5 flex items-center justify-center text-primary-600" />
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900 mb-1">{exotic.name}</h3>
                        <p className="text-sm text-gray-600 mb-2">{exotic.desc}</p>
                        <p className="text-xs text-primary-600 font-medium">
                          <i className="ri-heart-line w-3 h-3 inline mr-1" />
                          {exotic.care}
                        </p>
                      </div>
                    </div>
                  </div>
                </FadeIn>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-primary-950">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto text-center">
            <FadeIn>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                Egzotik Dostunuz İçin Özel Bakım
              </h2>
              <p className="text-white/70 mb-8 max-w-2xl mx-auto text-lg">
                Kuş ve egzotik hayvanlarınızın sağlığı için hemen randevu alın.
                Özel eğitimli veteriner hekimlerimiz size yardımcı olmaktan mutluluk duyacaktır.
              </p>
              <a
                href="tel:05396960677"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-bold rounded-xl transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                0539 696 06 77
              </a>
            </FadeIn>
          </div>
        </div>
      </section>
    </main>
  );
}
